// Property listing status (Property.status)
export const PROPERTY_LISTING_STATUS = {
  AVAILABLE: '1',
  RENTED: '2',
  PENDING: '3',
  UNAVAILABLE: '4',
  COMPLETED: '5',
};

export const PROPERTY_LISTING_STATUS_LABELS = {
  [PROPERTY_LISTING_STATUS.AVAILABLE]: 'Available',
  [PROPERTY_LISTING_STATUS.RENTED]: 'Rented',
  [PROPERTY_LISTING_STATUS.PENDING]: 'Pending',
  [PROPERTY_LISTING_STATUS.UNAVAILABLE]: 'Unavailable',
  [PROPERTY_LISTING_STATUS.COMPLETED]: 'Completed',
};

const STATUS_SLUGS = {
  [PROPERTY_LISTING_STATUS.AVAILABLE]: 'available',
  [PROPERTY_LISTING_STATUS.RENTED]: 'rented',
  [PROPERTY_LISTING_STATUS.PENDING]: 'pending',
  [PROPERTY_LISTING_STATUS.UNAVAILABLE]: 'unavailable',
  [PROPERTY_LISTING_STATUS.COMPLETED]: 'completed',
};

/** Normalize API / legacy values to a status code ('1'–'5'). */
export const normalizePropertyListingStatus = (raw) => {
  if (raw == null || raw === '') return null;
  const s = String(raw).trim();
  if (Object.values(PROPERTY_LISTING_STATUS).includes(s)) return s;

  const lower = s.toLowerCase();
  const byName = {
    available: PROPERTY_LISTING_STATUS.AVAILABLE,
    active: PROPERTY_LISTING_STATUS.AVAILABLE,
    rented: PROPERTY_LISTING_STATUS.RENTED,
    pending: PROPERTY_LISTING_STATUS.PENDING,
    unavailable: PROPERTY_LISTING_STATUS.UNAVAILABLE,
    completed: PROPERTY_LISTING_STATUS.COMPLETED,
  };
  return byName[lower] ?? null;
};

export const getPropertyListingStatusLabel = (raw) => {
  const code = normalizePropertyListingStatus(raw);
  return code ? PROPERTY_LISTING_STATUS_LABELS[code] : '—';
};

export const getPropertyListingStatusSlug = (raw) => {
  const code = normalizePropertyListingStatus(raw);
  return code ? STATUS_SLUGS[code] : 'unknown';
};

export const isAvailablePropertyStatus = (raw) =>
  normalizePropertyListingStatus(raw) === PROPERTY_LISTING_STATUS.AVAILABLE;
